import type { CarGroup, MemberGroup } from '../Notifications/notificationGroupTypes';

export type DriverContact = Pick<MemberGroup, 'userId' | 'firstName' | 'lastName' | 'phoneNumber' | 'email'>;

export const getDriversForCars = (carIds: number[], cars?: CarGroup[]): DriverContact[] => {
  const ids = new Set(carIds);
  const seen = new Set<number>();
  const drivers: DriverContact[] = [];

  for (const car of cars ?? []) {
    const member = car.manager;
    if (!member || !ids.has(car.carId) || seen.has(member.userId)) {
      continue;
    }
    seen.add(member.userId);
    drivers.push(member);
  }

  return drivers;
};

export const driverSearchText = (drivers: DriverContact[]) =>
  drivers.map((driver) => [driverName(driver), driver.phoneNumber, driver.email].filter(Boolean).join(' ')).join(' ');

export const driverName = (driver: DriverContact) => `${driver.firstName} ${driver.lastName}`.trim();
